export const ScanDetailsTabEnum = {
  OVERVIEW: "SCAN_DETAILS_TAB_OVERVIEW",
  SCANNED_ASSETS: "SCAN_DETAILS_TAB_SCANNED_ASSETS",
  VULNERABILITIES: "SCAN_DETAILS_TAB_VULNERABILITIES",
  PORTS: "SCAN_DETAILS_TAB_PORTS",
  APPLICATIONS: "SCAN_DETAILS_TAB_APPLICATIONS",
  CERTIFICATES: "SCAN_DETAILS_TAB_CERTIFICATES",
  SUBDOMAINS: "SCAN_DETAILS_TAB_SUBDOMAINS",
};
